import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 100,
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 15,
      },
    },
  },
  HEADLINE: {
    fontFamily: theme.fontFamily,
    fontSize: "22pt",
    // fontWeight: "bold" as "bold",
    textAlign: "left",
    padding: "20px 0",
    mobile: {
      desktop: {
        fontSize: "22pt",
      },
      smartphone: {
        fontSize: "18pt",
      },
    },
  },
  TEXT: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "left",
    lineHeight: "18pt",
    paddingBottom: 40,
    paddingTop: 20,
  },
  LIST: { paddingLeft: 0 },
  LI: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "left",
    lineHeight: "18pt",
    padding: "10px 0",
  },
};
